
<section *ngIf="isLoggedIn == false" class="section section-search" data-background="assets/img/reg-bg.png" style="background-image: url(assets/img/reg-bg.png);">
    <div class="container">
        <div class="row justify-content-md-center">
            <div class="col-md-auto col-xs-6 register-area" style="margin-top: 10px; margin-bottom:10px; margin-left: 10px; margin-right: 10px;">


                <ul class="list-inline register-content">
                    <li class="list-inline-item">
                        <h5 class="cate">New Bidders</h5>
                        <h3 class="title">
                            <a href="#/register">Click here to register</a>
                        </h3>
                    </li>
                    <li class="list-inline-item">
                        <h5 class="cate">Already a bidder</h5>
                        <h3 class="title">
                            <a href="#/login">Sign in here</a>
                        </h3>
                    </li>
                     
                </ul>
                
            </div>
            
        </div>
        <div class="row justify-content-md-center">
            <div class="col-md-auto col-xs-12 app-store-section">
                <div class="store-badges">
                    <h5 class="download-title">Download our mobile app</h5>
                    <div class="badge-container">
                        <a href="https://apps.apple.com/in/app/govtow-bidder/id1538448983" target="_blank" class="apple-badge">
                            <img src="assets/img/app-store-apple.svg" alt="Download on App Store" class="store-badge-img">
                        </a>
                        <a href="https://play.google.com/store/apps/details?id=com.govtow.govtow&hl=en_IN" target="_blank" class="google-badge">
                            <img src="assets/img/google-play-badge.svg" alt="Get it on Google Play" class="store-badge-img">
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<!--Slider-->
<div id="carouselExampleIndicators" class="carousel slide" data-ride="carousel">
    <ol class="carousel-indicators">
        <li data-target="#bootstrap-touch-slider" data-slide-to="0" class="active"></li>
        <li data-target="#bootstrap-touch-slider" data-slide-to="1"></li>
        <li data-target="#bootstrap-touch-slider" data-slide-to="2"></li>
    </ol>

    <div class="carousel-inner toptoscroll">
        <div class="carousel-item active">
            <img class="d-block w-100" src="assets/img/sliderimg1.jpg" alt="First slide">
            <div class="bs-slider-overlay"></div>
            <div class="container">
                <div class="row">
                    <!-- Slide Text Layer -->
                    <div class="slide-text slide_style_left">
                        <h1 data-animation="animated zoomInRight">GovTow Auctions</h1>
                        <p data-animation="animated fadeInLeft">We have two types of auctions
                            <br> live (with an auctioneer) and online.</p>
                        <a class="btn btn-yellow btn-lg col-3" data-animation="animated fadeInLeft" routerLink="/register" style="display: none;">
                            REGISTER NOW
                            <span style="margin-left: 5em;">
                                <i class="fa fa-long-arrow-alt-right"></i>
                            </span>
                        </a>
                    </div>
                </div>
            </div>
        </div>



        <div class="carousel-item">
            <img class="d-block w-100" src="assets/img/sliderimg2.jpg" alt="Second slide">
            <div class="bs-slider-overlay"></div>
            <div class="container">
                <div class="row">
                    <!-- Slide Text Layer -->
                    <div class="slide-text slide_style_left">
                        <h1 data-animation="animated zoomInRight">GovTow Auctions</h1>
                        <p data-animation="animated fadeInLeft">We have two types of auctions
                            <br> live (with an auctioneer) and online.</p>
                        <a class="btn btn-yellow btn-lg col-3" data-animation="animated fadeInLeft" routerLink="/register" style="display: none;">
                            REGISTER NOW
                            <span style="margin-left: 5em;">
                                <i class="fa fa-long-arrow-alt-right"></i>
                            </span>
                        </a>

                    </div>
                </div>
            </div>
        </div>
        <div class="carousel-item">
            <img class="d-block w-100" src="assets/img/sliderimg3.jpg" alt="Third slide">
            <div class="bs-slider-overlay"></div>
            <div class="container">
                <div class="row">
                    <!-- Slide Text Layer -->
                    <div class="slide-text slide_style_left">
                        <h1 data-animation="animated zoomInRight">GovTow Auctions</h1>
                        <p data-animation="animated fadeInLeft">We have two types of auctions
                            <br> live (with an auctioneer) and online.</p>
                        <a class="btn btn-yellow btn-lg col-3" data-animation="animated fadeInLeft" routerLink="/register" style="display: none;">
                            REGISTER NOW
                            <span style="margin-left: 5em;">
                                <i class="fa fa-long-arrow-alt-right"></i>
                            </span>
                        </a>

                    </div>
                </div>
            </div>
        </div>
    </div>
    <a class="carousel-control-prev" href="#carouselExampleIndicators" role="button" data-slide="prev">
        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
        <span class="sr-only">Previous</span>
    </a>
    <a class="carousel-control-next" href="#carouselExampleIndicators" role="button" data-slide="next">
        <span class="carousel-control-next-icon" aria-hidden="true"></span>
        <span class="sr-only">Next</span>
    </a>
</div>


<div class="container-fluid pt-5 pb-5">
    <div class="row">
        <div class="col-xs-12 col-sm-12">
            <h4 class="section_intro font22 font-wt800">
                Our Latest Auction
            </h4>
            <div class="s-border"></div>
            <div class="m-border"></div>
            <p class="text2">
                We have two types of auctions – live (with an auctioneer) and online. Online auctions are either held exclusively on our
                website or onsite at the sellers location.
            </p>
        </div>
    </div>
    <div class="row">
        <div class="col-md-12 col-xs-12 text-center mt-3 pt-3 pb-3 border-top border-bottom bg-grey">
            <span class="mx-0">
                <button class="fancy-button medium blueRiver vertical" (click)='navigate("currentauctions");'>
                    Current Auctions <span class="icon"> <i class="fa fa-arrow-circle-up"></i> </span>
                </button>
            </span>
            <span class="mx-2">
                <button class="fancy-button medium blueRiver vertical" (click)='navigate("upcomingauctions");'>
                    Upcoming Auctions <span class="icon"> <i class="fa fa-arrow-circle-up"></i> </span>
                </button>
            </span>
            <!-- <span class="mx-2">
                <button class="fancy-button medium blueRiver vertical" (click)='navigate("upcomingauctionsbyseller");'>
                    Upcoming Auctions Vehicles<span class="icon"> <i class="fa fa-arrow-circle-up"></i> </span>
                </button>
            </span> -->
        </div>
    </div>
    <div class="row mt20">
        <div class="col-md-4 col-sm-12 col-xs-12 mb10">
            <div class="feature-container">
                <img src="assets/img/featureimg1.jpg" alt="Card image cap" style="width:100%;">
                <div class="content">
                    <h1>GovTow Auction Types</h1>
                    <p>An online auction is an auction which is held over the internet</p>
                </div>
            </div>
        </div>
        <div class="col-md-4 col-sm-12 col-xs-12  mb10">
            <div class="feature-container">
                <img src="assets/img/featureimg2.jpg" alt="Card image cap" style="width:100%;">
                <div class="content">
                    <h1>Online Payment</h1>
                    <p>Online Auction provides several Online Payment System</p>
                </div>
            </div>
        </div>
        <div class="col-md-4 col-sm-12 col-xs-12 mb10">
            <div class="feature-container">
                <img src="assets/img/featureimg3.jpg" alt="Card image cap" style="width:100%;">
                <div class="content">
                    <h1>Why GovTow Auction</h1>
                    <p>Online Auction provides several Online Payment System</p>
                </div>
            </div>
        </div>
    </div>

    <div class="row mt20">
        <div class="col-md-4 col-sm-12 col-xs-12 mb10">
            <div class="imgcontainer">
                <img src="assets/img/featureimg4.jpg" alt="Nature" style="width:100%;">
                <div class="text-block">
                    <p>Explore Your Options</p>
                </div>
            </div>
        </div>
        <div class="col-md-4 col-sm-12 col-xs-12  mb10">
            <div class="imgcontainer">
                <img src="assets/img/featureimg5.jpg" alt="Card image cap" style="width:100%;">
                <div class="text-block">
                    <p>Bid From Your Home</p>
                </div>
            </div>
        </div>
        <div class="col-md-4 col-sm-12 col-xs-12 mb10">
            <div class="imgcontainer">
                <img src="assets/img/featureimg6.jpg" alt="Card image cap" style="width:100%;">
                <div class="text-block">
                    <p>Save Time and Money</p>
                </div>
            </div>
        </div>
    </div>
    
</div>